module.exports = __webpack_public_path__ + "static/step-hand-e0b3ea7bce7f8e3ea030a8c1a8b6fc17.svg";